import { render, staticRenderFns } from "./AdminAlertGroupNumberList.vue?vue&type=template&id=2090ec63"
import script from "./AdminAlertGroupNumberList.vue?vue&type=script&lang=js"
export * from "./AdminAlertGroupNumberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports